import { ProductStoreClientPage } from 'src/routes/payments/store/client/page';
import { RouteAction } from 'src/routes/types';

const action: RouteAction = () => {
  return {
    chunks: ['store'],
    title: 'Store',
    component: <ProductStoreClientPage />,
  };
};

export default action;
